// extracted by mini-css-extract-plugin
export var modal = "_az-0";